exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".module-create-emoji{display:flex;justify-content:center}.module-create-emoji .module-create-emoji-toggle{margin-top:1.5rem;margin-bottom:1.5rem;cursor:pointer}.module-create-emoji .module-create-emoji-toggle.module-create-emoji-toggle--default{border-radius:10em;outline:2px dashed var(--fts-border);outline-offset:.5rem;filter:grayscale(1);opacity:.5}.module-create-emoji .module-create-emoji-toggle.module-create-emoji-toggle--default:hover{filter:grayscale(0);opacity:1}.module-create-emoji .module-create-emoji-toggle.module-create-emoji-toggle--disabled{cursor:not-allowed}", ""]);

// exports
